import { TextBox } from '@apply/components';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface PlumbingFixturesDescriptionProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const PlumbingFixturesDescription: React.FC<PlumbingFixturesDescriptionProps> = ({
    required,
    readOnly,
    propertyGuid,
    isReview = false,
}) => {
    const [plumbingFixtures, set_plumbingFixtures] = useBudgetFixFlipField<string>(
        propertyGuid,
        (b) => (b.values?.['Interior']?.['Plumbing Fixtures']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Interior': { ...b.values?.['Interior'], 'Plumbing Fixtures': [v, b.values?.['Interior']?.['Plumbing Fixtures']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={plumbingFixtures}
                />
            ) : (
                <TextBox
                    value={plumbingFixtures}
                    onChange={(value) => set_plumbingFixtures(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
